module.exports = `${require.publicPath}home-img04.43dfeff7.png`;